import ReactGA from 'react-ga'
import TagManager from 'react-gtm-module'
import Cookies from 'js-cookie'
import {
  GATSBY_GOOGLE_ANALYTICS_COOKIE_NAME,
  GATSBY_GOOGLE_TAG_MANAGER_COOKIE_NAME,
} from '../lib/global'

type AnalyticsCookies = {
  gaCookie: string | undefined
  tmCookie: string | undefined
}

export const getAnalyticsCookies = () => {
  const cookies = {} as AnalyticsCookies

  if (process.env.GATSBY_GOOGLE_ANALYTICS_ID) {
    cookies.gaCookie = Cookies.get(GATSBY_GOOGLE_ANALYTICS_COOKIE_NAME)
  }

  if (process.env.GATSBY_GOOGLE_TAG_MANAGER_ID) {
    cookies.tmCookie = Cookies.get(GATSBY_GOOGLE_TAG_MANAGER_COOKIE_NAME)
  }

  return cookies
}

// Make sure all analytics cookies are 'true'
export const allowAnalyticsCookiesPresent = () => {
  const cookies: AnalyticsCookies = getAnalyticsCookies()

  for (const key in cookies) {
    const value = cookies[key as keyof AnalyticsCookies]
    if (value !== 'true') {
      return false
    }
  }
  return true
}

export const insertAnalyticScripts = () => {
  if (process.env.GATSBY_GOOGLE_ANALYTICS_ID) {
    ReactGA.initialize(process.env.GATSBY_GOOGLE_ANALYTICS_ID)
    ReactGA.pageview(window.location.pathname)
  }

  if (process.env.GATSBY_GOOGLE_TAG_MANAGER_ID) {
    TagManager.initialize({ gtmId: process.env.GATSBY_GOOGLE_TAG_MANAGER_ID })
  }
}
